// Helpers for saving a blob response to disk.
//
// The server decides the export format, so the filename and extension come from
// its Content-Disposition header rather than being hardcoded per call site —
// hardcoding is how "app_users.xlsx" ended up on a CSV payload.
//
// Caveat: the browser only exposes Content-Disposition to JS when the response
// carries `Access-Control-Expose-Headers: Content-Disposition`. The API is on a
// different origin than the SPA, so until the backend sends that header the
// parse below finds nothing and the caller's fallback name is used.

function safeDecode(value) {
  try {
    return decodeURIComponent(value);
  } catch (err) {
    return "";
  }
}

export function filenameFromResponse(response, fallback) {
  const headers = (response && response.headers) || {};
  const disposition =
    headers["content-disposition"] || headers["Content-Disposition"] || "";

  // RFC 5987's `filename*=UTF-8''…` form takes precedence over plain filename=.
  const encoded = /filename\*=\s*UTF-8''([^;]+)/i.exec(disposition);
  if (encoded) {
    const decoded = safeDecode(encoded[1].trim());
    if (decoded) return decoded;
  }

  const plain = /filename\s*=\s*"?([^";]+)"?/i.exec(disposition);
  if (plain) return plain[1].trim();

  return fallback;
}

// Trigger a download for an axios `responseType: "blob"` response.
export function saveBlobResponse(response, fallbackName) {
  const headers = (response && response.headers) || {};
  const contentType = headers["content-type"] || headers["Content-Type"] || "";
  const blob = contentType
    ? new Blob([response.data], { type: contentType })
    : new Blob([response.data]);

  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filenameFromResponse(response, fallbackName));
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}
